import { getMessages } from '../../../../../../store/constants';
import { CLASS_BOARD_DETAILS } from '../../constants';

export const CLASS_BOARD_CARD_CUSTOM = CLASS_BOARD_DETAILS + '-card-custom';

export const BOARD_SECTION_CARD_CUSTOM_PROPERTIES_BUTTON = getMessages().getText('board_settings.card_custom_properties.button');
